import { DocumentationArea } from "src/contexts/documentationArea/domain/DocumentationArea";
import { ActorId } from "src/contexts/documentationArea/domain/ActorId";
import { useAuth } from "./useAuth";
import { useDependencies } from "./useDependencies";
import { useDocumentationAreaMutation } from "./useDocumentationAreaMutation";
import { DocumentationAreaId } from "src/contexts/documentationArea/domain/DocumentationAreaId";

export type MarkNotificationAsDeliveredData = {
  documentationAreaId: DocumentationAreaId | null;
  actorId: ActorId | null;
  notificationId: string;
};

export const useMarkNotificationAsDelivered = () => {
  const { token } = useAuth();
  const { documentationAreaController } = useDependencies();

  const mutationFn = async (data: MarkNotificationAsDeliveredData) => {
    if (!data.documentationAreaId) {
      throw new Error("Documentation area ID is required");
    }
    if (!data.actorId) {
      throw new Error("Actor ID is required");
    }

    await documentationAreaController.deliverNotification(
      token,
      data.documentationAreaId,
      data.actorId,
      data.notificationId,
    );
  };

  const optimisticUpdate = (
    input: MarkNotificationAsDeliveredData,
    documentationArea: DocumentationArea,
  ) => {
    documentationArea
      .getActor()
      .getNotifications()
      .map((notification) => {
        if (notification.id === input.notificationId) {
          notification.delivered = true;
        }
      });

    return documentationArea;
  };

  const {
    mutate: markNotificationAsDelivered,
    isSuccess,
    isError,
  } = useDocumentationAreaMutation<void, MarkNotificationAsDeliveredData>({
    mutationFn,
    optimisticUpdate,
  });

  return { markNotificationAsDelivered, isSuccess, isError };
};
